import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ArrowLeftIcon, ClockIcon, FacebookIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { business, routes } from '../data/site';
import { SiteLink } from '../components/SiteLink';
type ComingSoonProps = {
  title: string;
};
export function ComingSoon({
  title
}: ComingSoonProps) {
  const {
    pathname
  } = useLocation();
  const isContactPage = pathname === routes.contact;
  useEffect(() => {
    document.title = `${title} | Pegasus Spas`;
    window.scrollTo(0, 0);
  }, [title]);
  return <main data-id="element-976" data-mp="97kgkizxq6a9">
      <section className="w-full bg-water" data-id="element-977" data-mp="n120i4wj9l0t">
        <div className="mx-auto max-w-container px-5 py-16 sm:px-8 lg:py-20" data-id="element-978" data-mp="n00cz0ybz627">
          <p className="text-[14px] font-bold uppercase text-pegasus-blue" data-id="element-979" data-mp="i1gr10jqlu9u">Pegasus Spas</p>
          <h1 className="mt-2 text-h1-mobile font-semibold text-ink lg:text-h1-desktop" data-id="element-980" data-mp="wyzkgg7d0vnm">{title}</h1>
          <p className="mt-4 max-w-2xl text-body text-ink/80 sm:text-body-lg" data-id="element-981" data-mp="s0eioccgm3x2">
            This page is coming soon. In the meantime, call or text the showroom and we will help
            you directly.
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3" data-id="element-982" data-mp="124bcf20k2sc8">
            <SiteLink to={routes.home} className="inline-flex min-h-[48px] items-center gap-2 rounded-btn bg-pegasus-magenta px-6 text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-[#bb2f83]" data-id="element-983" data-mp="166offinx4c5b">
              <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-984" data-mp="1g4m2w3xye4wv" />
              Back to Home
            </SiteLink>
            <a href={business.phoneHref} className="inline-flex min-h-[48px] items-center gap-2 rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-white" data-id="element-985" data-mp="1l1m9cfypt9oi">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-986" data-mp="1ywx0bi9u9anl" />
              Call or text {business.phone}
            </a>
            {isContactPage && <a href={routes.facebook} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[48px] items-center gap-2 rounded-btn border border-ink/25 px-5 text-[16px] font-medium text-ink transition-colors duration-150 ease-out hover:bg-white" data-id="element-987" data-mp="3rnv8280o4u6">
                <FacebookIcon className="h-4 w-4" aria-hidden="true" data-id="element-988" data-mp="8ppgmtsx0g8t" />
                Follow Pegasus on Facebook
              </a>}
          </div>
        </div>
      </section>

      <section aria-label="Showroom details" className="w-full bg-white" data-id="element-989" data-mp="igbo20qha0gf">
        <div className="mx-auto grid max-w-container grid-cols-1 gap-6 px-5 py-12 sm:grid-cols-2 sm:px-8" data-id="element-990" data-mp="wh4jqosin1l4">
          <div className="flex items-start gap-2.5" data-id="element-991" data-mp="ritb2hdyix4h">
            <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-992" data-mp="rfyskvei7mdp" />
            <address className="text-[16px] not-italic leading-6 text-ink" data-id="element-993" data-mp="2ya2h8xx8mice">
              {business.street}
              <br data-id="element-994" data-mp="18r3xbrxpox3a" />
              {business.cityStateZip}
            </address>
          </div>
          <div className="flex items-start gap-2.5" data-id="element-995" data-mp="18tggu9j4bfig">
            <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-996" data-mp="1dovr6rhx2ta4" />
            <div className="text-[16px] leading-6 text-ink" data-id="element-997" data-mp="z0j30gp2meq6">
              {business.hours.map(entry => <div key={entry.days} data-id="element-998" data-mp="13ysy6raspfbs">
                  {entry.days} {entry.time}
                </div>)}
            </div>
          </div>
        </div>
      </section>
    </main>;
}